export class AccountNote {
  id: string;
  merchantId: string | undefined;
  leadId: string | undefined;
  userId: string;
  userFirst: string | undefined;
  userLast: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  text: string;

  constructor(n: Partial<AccountNote>) {
    if (n.id == null)
      throw new Error(
        `Invalid AccountNote in constructor: ${JSON.stringify(n)} id cannot be null`,
      );
    if (n.userId == null)
      throw new Error(
        `Invalid AccountNote in constructor: ${JSON.stringify(n)} userId cannot be null`,
      );
    if (n.text == null)
      throw new Error(
        `Invalid AccountNote in constructor: ${JSON.stringify(n)} text cannot be null`,
      );

    this.id = n.id;
    this.merchantId = n.merchantId;
    this.leadId = n.leadId;
    this.userId = n.userId;
    this.createdAt = n.createdAt;
    this.updatedAt = n.updatedAt;
    this.text = n.text;
    this.userFirst = n.userFirst;
    this.userLast = n.userLast;
  }
}
